<script lang="ts">
  import { nrkLogoNrk } from '@nrk/core-icons/logo';
  import { loginSessionStore } from '../../login/loginSessionStore';
  import type { LoginSession } from '@nrk/innlogging-web/redirect-login-client';

  const interestingProps = (session: LoginSession | null) => {
    const sessionData = {
      isOffgrid: session?.isOffgrid,
      isExpired: session?.isExpired,
      expires:
        session != null
          ? new Date(session.expires).toLocaleString()
          : 'no data',
      accessToken: session?.accessToken,
    };
    return JSON.stringify(sessionData, null, 2);
  };
  $: sessionData = interestingProps($loginSessionStore);

  const searchParams = new URLSearchParams(window.location.search);
  const showInnloggingDebug = searchParams.get('login-debug') ?? undefined;
</script>

{#if showInnloggingDebug}
  <div class="innlogging-debug">
    <h2>
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html nrkLogoNrk} - Innlogging debug
    </h2>
    <code>
      {sessionData}
    </code>
  </div>
{/if}

<style>
  .innlogging-debug {
    border: 2px solid yellow;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 1rem;
    margin: 0.5rem;
  }

  code {
    white-space: pre-wrap;
    word-break: break-all;
  }
</style>
